import Icon from 'veui/components/Icon'
import { IconFolderOpen } from 'dls-icons-vue'

Icon.register('folder-open', IconFolderOpen)
